import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";

import {
  getAllPermitPackages,
  getPermitPackages,
  handleDownloadNoc,
  setRealEstatePresetsPermitPackage,
  updatePermitPackage,
  updatePermitPackageName,
} from "../dataActions";
import { updateAllNotifications } from "../notificationsActions";
import { updateAnalytics } from "../subUserActions";
import { getPermitTypeData } from "../../../components/permitForms/permitFormHelpers";
import { setBuildingState } from "../permitFormActions/buildingStateActions";

export const setRightValue = (value) => {
  return {
    type: "SET_RIGHT_VALUE",
    payload: value,
  };
};

export const setAttachingNewPermit = (data) => {
  return {
    type: "SET_ATTACHING_NEW_PERMIT",
    payload: data,
  };
};

export const setActiveTab = (value) => {
  return {
    type: "SET_ACTIVE_TAB",
    payload: value,
  };
};

export const setSelectedRow = (value) => (dispatch, getState) => {
  const { myPermitsComponent } = getState();
  const previousTaskId = myPermitsComponent?.selectedRow?.task_id;
  const newTaskId = value?.task_id;

  // If switching to a different package, reset package-specific state
  if (previousTaskId !== newTaskId) {
    dispatch(setBuildingState({ workDesc: "" }));
  }

  dispatch({
    type: "SET_SELECTED_ROW",
    payload: value,
  });
};

export const setSelectedPermitType = (permitType) => {
  return {
    type: "SET_SELECTED_PERMIT_TYPE",
    payload: permitType,
  };
};

export const setLeftValue = (value) => (dispatch, getState) => {
  const state = getState();
  const currentLeftValue = state.myPermitsComponent?.leftValue;

  if (currentLeftValue === value) {
    return;
  }

  dispatch({
    type: "SET_LEFT_VALUE",
    payload: value,
  });
};

export const setInstructionDownloading = (value) => {
  return {
    type: "SET_INSTRUCTION_DOWNLOADING",
    payload: value,
  };
};

export const clearMyPermitState = () => {
  return {
    type: "CLEAR_MY_PERMIT_STATES",
  };
};

export const setRealEstateAddressOptions = (value) => {
  return {
    type: "SET_REAL_ESTATE_ADDRESS_OPTIONS",
    payload: value,
  };
};

export const setRealEstateFetchLoading = (value) => {
  return {
    type: "SET_REAL_ESTATE_FETCH_LOADING",
    payload: value,
  };
};

export const setRealEstatePresetLoading = (value) => {
  return {
    type: "SET_REAL_ESTATE_PRESET_LOADING",
    payload: value,
  };
};

export const setCityPermitLoading = (value) => {
  return {
    type: "SET_CITY_PERMIT_LOADING",
    payload: value,
  };
};

export const setSelectedRealEstateAddress = (address) => {
  return {
    type: "SET_SELECTED_REAL_ESTATE_ADDRESS",
    payload: address,
  };
};

export const setSelectedRealEstateAddressTemp = (addresses) => {
  return {
    type: "SET_SELECTED_REAL_ESTATE_ADDRESS_TEMP",
    payload: addresses,
  };
};

export const handleSetMapType = (obj) => {
  return {
    type: "HANDLE_SET_MAP_TYPE",
    payload: obj,
  };
};

export const handleSetShowMap = (isMap) => {
  return {
    type: "HANDLE_SET_SHOW_MAP",
    payload: isMap,
  };
};

export const setRenderMapInitials = (obj) => {
  return {
    type: "SET_RENDER_MAP_INITIALS",
    payload: obj,
  };
};

export const setRealEstatePresetsSelectedRow = ({ data, address }) => {
  return {
    type: "SET_REAL_ESTATE_PRESETS_SELECTED_ROW",
    payload: { data, address },
  };
};

export const handlePreSaveCitySelections = (data) => {
  return {
    type: "PRE_SAVE_CITY_SELECTIONS",
    payload: data,
  };
};

export const resolveTempAddress = (address) => {
  return {
    type: "RESOLVE_TEMPLATE_ADDRESS",
    payload: address,
  };
};

export const setNoAddressError = (value) => {
  return {
    type: "SET_NO_ADDRESS_ERROR",
    payload: value,
  };
};

export const setChangePackageNameLoading = (value) => {
  return {
    type: "SET_CHANGE_PACKAGE_NAME_LOADING",
    payload: value,
  };
};

export const setMyPermitsSnackOpen = (obj) => {
  return {
    type: "SET_MY_PERMITS_SNACK_OPEN",
    payload: obj,
  };
};

export const setRowCount = (value) => {
  return {
    type: "SET_ROW_COUNT",
    payload: value,
  };
};

export const setPage = (value) => {
  return {
    type: "SET_PAGE",
    payload: value,
  };
};

export const setPageSize = (value) => {
  return {
    type: "SET_PAGE_SIZE",
    payload: value,
  };
};

export const setCityFailedErrorText = (value) => {
  return {
    type: "SET_CITY_FAILED_ERROR_TEXT",
    payload: value,
  };
};

export const setCurrentPopup = (value) => {
  return {
    type: "SET_CURRENT_POPUP",
    payload: value,
  };
};

export const setModalsState = (payload) => {
  return {
    type: "SET_MODALS_STATE",
    payload,
  };
};

export const setPermitLoadings = (payload) => {
  return {
    type: "SET_PERMIT_LOADINGS",
    payload,
  };
};

export const setDocumentImage = (value) => {
  return {
    type: "SET_DOCUMENT_IMAGE",
    payload: value,
  };
};

export const setCreatingDocTitle = (value) => {
  return {
    type: "SET_CREATING_DOC_TITLE",
    payload: value,
  };
};

export const setNumCreated = (value) => {
  return {
    type: "SET_NUM_CREATED",
    payload: value,
  };
};

export const clearRealEstate = () => {
  return {
    type: "CLEAR_REAL_ESTATE",
  };
};

export const setPermitPanelOpen = (value) => {
  return {
    type: "SET_PERMIT_PANEL_OPEN",
    payload: value,
  };
};

export const fillJaxFields = (payload) => {
  return {
    type: "FILL_JAX_FIELDS",
    payload,
  };
};

export const setJaxFieldsLoading = (value) => {
  return {
    type: "SET_JAX_FIELDS_LOADING",
    payload: value,
  };
};

export const setJaxFieldsFetchError = (value) => {
  return {
    type: "SET_JAX_FIELDS_FETCH_ERROR",
    payload: value,
  };
};

export const setPrevRowID = (value) => {
  return {
    type: "SET_PREV_ROW_ID",
    payload: value,
  };
};

export const setViewDocLoading = (id) => {
  return {
    type: "SET_VIEW_DOC_LOADING",
    payload: id,
  };
};

export const setCreateScheduleLoading = (value) => {
  return {
    type: "SET_CREATE_SCHEDULE_LOADING",
    payload: value,
  };
};

export const setScheduleOfValues = (payload) => {
  return {
    type: "SET_SCHEDULE_OF_VALUES",
    payload,
  };
};

export const pushSovTemplate = (payload) => {
  return {
    type: "PUSH_SOV_TEMPLATE",
    payload,
  };
};

export const setUsingTemplates = (payload) => {
  return {
    type: "SET_USING_TEMPLATES",
    payload,
  };
};

export const setSovTemplates = (payload) => {
  return {
    type: "SET_SOV_TEMPLATES",
    payload,
  };
};

export const updateScheduleOfValuesNeedCreate = (needCreate) => {
  return {
    type: "UPDATE_SCHEDULE_OF_VALUES_NEED_CREATE",
    payload: needCreate,
  };
};

export const updateJobCost = (jobCost) => {
  return {
    type: "UPDATE_JOB_COST",
    payload: jobCost,
  };
};

export const updateWorkDescription = (workDescription) => {
  return {
    type: "UPDATE_WORK_DESCRIPTION",
    payload: workDescription,
  };
};

export const initSovTemplate = (payload) => {
  return {
    type: "INIT_SOV_TEMPLATE",
    payload,
  };
};

export const removeSovTemplate = (id) => {
  return {
    type: "REMOVE_SOV_TEMPLATE",
    payload: id,
  };
};

export const updateJaxDoc = (obj) => {
  return {
    type: "UPDATE_JAX_DOC",
    payload: obj,
  };
};

export const updateNocDocument = (noc) => {
  return {
    type: "UPDATE_NOC_DOCUMENT",
    payload: noc,
  };
};

export const fillCommonValues = (noc) => {
  return {
    type: "FILL_COMMON_VALUES",
  };
};

export const setCityPermitButtonDisabled = (val) => {
  return {
    type: "SET_CITY_PERMIT_BUTTON_DISABLED",
    payload: val,
  };
};

// Revert only fields whose value differs from the original selectedRow.common_fields
export const revertChangedCommonValues = () => (dispatch, getState) => {
  const state = getState();
  const current = state.myPermitsComponent?.commonValues ?? [];
  const original = state.myPermitsComponent?.selectedRow?.common_fields ?? [];

  if (!Array.isArray(current) || !Array.isArray(original)) {
    return;
  }

  // Build a quick lookup by common_name for the originals
  const originalByName = new Map(original.map((o) => [o.common_name, o]));

  // Helper: equality (tweak normalization if you want trim/number casting)
  const isEqual = (a, b) => {
    // Treat NaN as equal
    if (
      typeof a === "number" &&
      typeof b === "number" &&
      Number.isNaN(a) &&
      Number.isNaN(b)
    ) {
      return true;
    }
    return a === b;
  };

  // Collect differences
  const diffs = [];
  for (const cur of current) {
    const orig = originalByName.get(cur.common_name);
    if (!orig) continue; // not present in original -> ignore

    if (!isEqual(cur?.value, orig?.value)) {
      diffs.push({ common_name: cur.common_name, value: orig?.value });
    }
  }

  if (diffs.length === 0) {
    // nothing to revert
    return;
  }

  // ---- Option A: batch update in a single action (recommended for performance)
  dispatch({ type: "REVERT_COMMON_VALUES", payload: diffs });
};

// COMMON VALUES /////////////////////////////////////////////////////
export const setCommonValue =
  (fieldName, fieldValue) => async (dispatch, getState) => {
    const state = getState();
    const commonFields = state.myPermitsComponent?.commonValues;

    if (!commonFields || !Array.isArray(commonFields)) {
      return;
    }

    const normalize = (str) =>
      str
        .toLowerCase()
        .trim()
        .replace(/[\s-]+/g, "_")
        .replace(/_+/g, "_");

    const escaped = fieldName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const aliasRegex = new RegExp(`^${escaped}$`, "i");

    const index = commonFields.findIndex((item) =>
      (item.fields || []).some((f) => aliasRegex.test(normalize(f))),
    );

    if (index === -1) {
      // Warn once per session for this alias to avoid console spam
      window.__missingCommonFieldWarnings =
        window.__missingCommonFieldWarnings || new Set();
      const key = String(fieldName).toLowerCase();
      if (!window.__missingCommonFieldWarnings.has(key)) {
        window.__missingCommonFieldWarnings.add(key);
      }
      return;
    }

    const matchedField = commonFields[index];

    if (matchedField.locked) {
      return;
    }

    dispatch({
      type: "UPDATE_COMMON_VALUE",
      payload: {
        common_name: matchedField.common_name,
        value: fieldValue,
      },
    });
  };
//////////////////////////////////////////////////////////////////////

//! DOWNLOAD INSTRUCTIONS ////////////////////////////////////////////
export const handleDownloadInstructions = () => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const { selectedRow, leftValue, selectedPermitType } =
    state.myPermitsComponent;

  const currentPermitData = getPermitTypeData(selectedRow, selectedPermitType);

  try {
    await dispatch(
      setInstructionDownloading(
        currentPermitData?.selected_documents?.[leftValue]?.name +
          "inst" +
          selectedRow?.task_id,
      ),
    );

    const currentForm =
      currentPermitData?.selected_documents?.[leftValue]?.name || "pais";
    const isMainPermitType = selectedPermitType === selectedRow?.permit_type;

    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/data/download-instructions`,
      {
        task_id: selectedRow?.task_id,
        currentSession: currentSession,
        currentForm: currentForm,
        selectedPermitType: selectedPermitType,
        mainPermitType: isMainPermitType,
      },
      {
        withCredentials: true,
        responseType: "blob",
      },
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    let fileNameRaw =
      (selectedRow?.project_name || "project") + "-instructions";
    let fileName =
      fileNameRaw
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^\w-]+/g, "") + ".zip";

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    // optional: handle error
  } finally {
    dispatch(setInstructionDownloading(false));
  }
};

export const fetchRealEstateAddress =
  (address) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow } = state.myPermitsComponent;

    try {
      await dispatch(setRealEstateFetchLoading(true));

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/real-estate/search`,
        {
          currentSession: currentSession,
          county: selectedRow?.county,
          address,
        },
        {
          withCredentials: true,
        },
      );

      if (res?.data?.success) {
        await dispatch(setRealEstateAddressOptions(res?.data?.data));
        return res?.data?.data;
      }
    } catch (error) {
      dispatch(setRealEstateAddressOptions([]));
    } finally {
      dispatch(setRealEstateFetchLoading(false));
    }
  };

export const handleRealEstatePreset =
  (formikValues) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow, realEstate } = state.myPermitsComponent;

    try {
      await dispatch(setRealEstatePresetLoading(true));
      dispatch(setCityFailedErrorText(""));

      let fetchedAddress = null;

      if (realEstate?.selectedAddressShort) {
        fetchedAddress = await dispatch(
          fetchRealEstateAddress(realEstate?.selectedAddressShort),
        );
        if (fetchedAddress.length === 0) {
          return false;
        }
        await dispatch(resolveTempAddress(fetchedAddress?.[0]));
      }

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/real-estate/preset/${selectedRow?.county.toLowerCase().replace(" ", "_")}`,
        {
          currentSession: currentSession,
          task_id: selectedRow?.task_id,
          selected_address: !fetchedAddress
            ? realEstate?.selectedAddress
            : fetchedAddress?.[0],
          county: selectedRow?.county,
          form_field_obj: formikValues,
        },
        {
          withCredentials: true,
        },
      );

      if (res?.data?.success) {
        if (res?.data?.city_connected) {
          await dispatch(
            setRealEstatePresetsSelectedRow({
              data: res?.data?.data,
              address: !fetchedAddress
                ? realEstate?.selectedAddress
                : fetchedAddress?.[0],
            }),
          );
          await dispatch(
            setRealEstatePresetsPermitPackage({
              realEstatePresets: res?.data?.data,
              task_id: selectedRow?.task_id,
            }),
          );
        } else {
          dispatch(handleSetShowMap(false));
        }
      }
    } catch (error) {
      return false;
    } finally {
      dispatch(setRealEstatePresetLoading(false));
    }
  };

// ALSO CREATES NOC
export const handleGeneratePermitNumber =
  (formikValues, usePPforPlanReview) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow, citySite } = state.myPermitsComponent;

    try {
      await dispatch(setCityPermitLoading(true));
      dispatch(setCityFailedErrorText(""));

      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/city_permit/generate-permit-number`,
        {
          currentSession: currentSession,
          task_id: selectedRow?.task_id,
          mini_map: citySite.fullPermitMap,
          form_field_obj: formikValues,
          use_pp_for_plan_review: usePPforPlanReview,
        },
        {
          withCredentials: true,
        },
      );

      if (res?.data?.success) {
        dispatch(handleSetShowMap(false));
        return { success: true };
      } else {
        await dispatch(
          setCityFailedErrorText(
            res?.data?.message ||
              "City server is currently unavailable or slow to respond. Please try again in a few minutes.",
          ),
        );
        return {
          success: false,
          error_type: res?.data?.error_type,
          message: res?.data?.message,
          city_user_id: res?.data?.city_user_id,
          city_user_name: res?.data?.city_user_name,
          county: res?.data?.county,
          city: res?.data?.city,
        };
      }
    } catch (error) {
      const errorData = error.response?.data || {};
      const errorText =
        errorData?.message ||
        error.message ||
        "City server is currently unavailable or slow to respond. Please try again in a few minutes.";
      await dispatch(setCityFailedErrorText(errorText));
      return {
        success: false,
        error_type: errorData?.error_type,
        message: errorText,
        city_user_id: errorData?.city_user_id,
        city_user_name: errorData?.city_user_name,
        county: errorData?.county,
        city: errorData?.city,
      };
    } finally {
      dispatch(setCityPermitLoading(false));
    }
  };

export const handleUpdateCityCredentials =
  (city_user_id, username, password, county, city) =>
  async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/city_permit/update-city-credentials`,
        {
          currentSession: currentSession,
          city_user_id,
          username,
          password,
          county,
          city,
        },
        {
          withCredentials: true,
        },
      );

      return res?.data;
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to update credentials",
      };
    }
  };

export const handleRemoveCityConnection =
  (task_id) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/city_permit/remove-city-connection`,
        {
          currentSession: currentSession,
          task_id,
        },
        {
          withCredentials: true,
        },
      );

      if (res?.data?.success && res?.data?.data) {
        // Update selectedRow with the updated package
        await dispatch(setSelectedRow(res.data.data));
      }

      return res?.data;
    } catch (error) {
      return {
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to remove city connection",
      };
    }
  };

export const handleCancelPermit =
  (
    cancelPermitComment,
    selectedPermitType = null,
    isAdditionalPermit = false,
    isReadOnlyPage = false,
  ) =>
  async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow } = state.myPermitsComponent;
    const { rowCount, pageSize } = state.myPermitsComponent.permits.pagination;
    const notifications = state.notifications;

    try {
      await dispatch(setPermitLoadings({ cancelPermitLoading: true }));

      const voidPermit = selectedRow?.connect_to_city?.permit?.permit_id;

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/building/cancel-permit-package`,
        {
          task_id: selectedRow?.task_id,
          currentSession: currentSession,
          voidPermit: voidPermit,
          cancelPermitComment: cancelPermitComment,
          selectedPermitType: selectedPermitType,
          isAdditionalPermit: isAdditionalPermit,
          notifications: {
            noc: {
              curr_page: notifications?.noc?.pagination?.page,
            },
            package: {
              curr_page: notifications?.package?.pagination?.page,
            },
            requests: {
              curr_page: notifications?.requests?.pagination?.page,
            },
          },
        },
        {
          withCredentials: true,
        },
      );
      if (resp?.data?.success) {
        await dispatch(setPermitLoadings({ dataLoading: true }));

        if (isAdditionalPermit) {
          // For additional permit removal, update the selected row with new data
          if (resp?.data?.updatedPackage) {
            await dispatch(setSelectedRow(resp.data.updatedPackage));
            // Reset selectedPermitType to main permit type after removing additional permit
            await dispatch(setSelectedPermitType(selectedRow.permit_type));
          }
        } else {
          // For main permit package removal, clear selection and refresh list
          await dispatch(setSelectedRow(null));
          await dispatch(setPage(0));
          await dispatch(setPageSize(pageSize));
          await dispatch(setRowCount(rowCount - 1));
        }

        if (isReadOnlyPage) {
          await dispatch(
            getAllPermitPackages({ newPage: 0, newPageSize: pageSize }),
          );
        } else {
          await dispatch(
            getPermitPackages({ newPage: 0, newPageSize: pageSize }),
          );
        }
        await dispatch(updateAllNotifications(resp?.data?.notifications));
        return true; // Return success indicator
      }
      return false; // Return failure indicator
    } catch (error) {
      return false; // Return failure indicator
    } finally {
      await dispatch(
        setPermitLoadings({ dataLoading: false, cancelPermitLoading: false }),
      );
    }
  };

export const handleEditPackageName =
  (packageName) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow } = state.myPermitsComponent;

    try {
      await dispatch(setChangePackageNameLoading(true));

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/building/edit-package-name`,
        {
          task_id: selectedRow?.task_id,
          packageName: packageName,
          currentSession: currentSession,
        },
        {
          withCredentials: true,
        },
      );
      if (resp?.data?.success) {
        await dispatch(
          updatePermitPackageName({
            task_id: selectedRow?.task_id,
            package_name: packageName,
          }),
        );
        return { success: true, message: resp?.data?.message };
      }
    } catch (error) {
      return { success: false, message: "Failed to Change Package Name" };
    } finally {
      await dispatch(setChangePackageNameLoading(false));
    }
  };

export const handlePayment = (activeStep) => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const currentUser = state[currentSession]?.user;
  const { selectedRow, currentPopup, leftValue } = state.myPermitsComponent;

  try {
    dispatch(setPermitLoadings({ paymentLoading: true }));

    let paymentCards = [];

    if (currentUser?.payment_cards?.length > 0) {
      paymentCards = currentUser.payment_cards.map((card) => {
        const lastTwo = String(card.exp_year).slice(-2);
        const first = card.exp_month;

        return {
          id: card.id,
          cardNum: "**** **** **** " + card.last4,
          cardName: card.name ? card.name : card.card_holder,
          expires:
            (first < 10 ? "0" + String(first) : String(first)) + "/" + lastTwo,
          default: card.default,
        };
      });
    }

    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/stripe/process-addition-payment`,
      {
        paymentCard: paymentCards?.[activeStep]?.id,
        task_id: selectedRow?.task_id,
        currentSession: currentSession,
        addition: currentPopup,
      },
      { withCredentials: true },
    );

    if (resp.data.success === false && resp.data.paid === true) {
      const res = await dispatch(handleDownloadNoc("pdf", "letter"));

      if (!res?.promoOpen) {
        await dispatch(
          setModalsState({ paymentModalOpen: false, promoModalOpen: false }),
        );
      }

      return;
    }

    const stripe = await loadStripe(process.env.REACT_APP_STRIPE);

    let result = null;

    if (resp.data.flow === "setup_intent") {
      result = await stripe.confirmCardSetup(resp.data.data);
    } else {
      result = await stripe.confirmCardPayment(resp.data.data);
    }

    if (!result.error) {
      let status = null;

      if (resp.data.flow === "setup_intent") {
        status = result.setupIntent.status;
      } else {
        status = result.paymentIntent.status;
      }

      if (status === "succeeded" && resp.data.valid === true) {
        const paymentIntent =
          resp.data.flow === "setup_intent"
            ? result.setupIntent
            : result.paymentIntent;

        const finalResp = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/nocApi/stripe/finish-addition-payment`,
          {
            paymentIntent,
            task_id: selectedRow?.task_id,
            currentSession: currentSession,
            addition: currentPopup,
            currentForm: selectedRow?.selected_documents?.[leftValue]?.name,
          },
          { withCredentials: true },
        );
        if (finalResp?.data?.success) {
          await dispatch(updatePermitPackage(finalResp?.data?.data));

          if (currentPopup === "downloadPayment") {
            await dispatch(updateAnalytics(finalResp?.data?.analytics));
            await dispatch(handleDownloadNoc("pdf", "letter"));
          }

          // setSnackOpen(true);
          dispatch(
            setModalsState({ promoModalOpen: false, paymentModalOpen: false }),
          );
        }
      }
    }
  } catch (e) {
  } finally {
    dispatch(setPermitLoadings({ paymentLoading: false }));
  }
};

export const fetchJaxFields = () => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const { selectedRow } = state.myPermitsComponent;

  try {
    await dispatch(setJaxFieldsLoading(true));
    dispatch(setJaxFieldsFetchError(null));

    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/city_permit/fetch-jax-inputs`,
      {
        task_id: selectedRow?.task_id,
        currentSession: currentSession,
      },
      {
        withCredentials: true,
      },
    );
    if (resp?.data?.success) {
      await dispatch(
        fillJaxFields({
          data: resp?.data?.data,
          documents: resp?.data?.documents,
        }),
      );

      return;
    } else {
      dispatch(setJaxFieldsFetchError("Permit not found or has been voided"));
      dispatch(fillJaxFields({ data: null, documents: null }));
      return;
    }
  } catch (error) {
    dispatch(setJaxFieldsFetchError("Permit not found or has been voided"));
    dispatch(fillJaxFields({ data: null, documents: null }));
    return;
  } finally {
    await dispatch(setJaxFieldsLoading(false));
    await dispatch(setPrevRowID(selectedRow?.task_id));
  }
};

export const getUploadedForm = (url) => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const { selectedRow } = state.myPermitsComponent;

  try {
    const parts = url.split("/");
    const documentId = parts[parts.length - 1];
    await dispatch(setViewDocLoading(documentId));

    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/city_permit/get-uploaded-form`,
      {
        task_id: selectedRow?.task_id,
        currentSession: currentSession,
        url: url,
      },
      {
        responseType: "blob",
        withCredentials: true,
      },
    );

    const blob = new Blob([resp.data], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  } catch (error) {
    console.error("Failed to load PDF", error);
  } finally {
    await dispatch(setViewDocLoading(null));
  }
};

const isBase64ImageDataUrl = (value) =>
  typeof value === "string" && value.startsWith("data:image/");

const isHttpUrl = (value) =>
  typeof value === "string" && /^https?:\/\//i.test(value);

export const handleCreateSchedule = (file) => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const { selectedRow } = state.myPermitsComponent;
  const { rows, totalCost, loadedLogo } =
    state.myPermitsComponent.scheduleOfValues;

  try {
    await dispatch(setCreateScheduleLoading(true));

    let normalizedLoadedLogo = loadedLogo;

    if (
      normalizedLoadedLogo &&
      !isBase64ImageDataUrl(normalizedLoadedLogo) &&
      !isHttpUrl(normalizedLoadedLogo)
    ) {
      normalizedLoadedLogo = "";
    }

    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/schedule-of-values/create-schedule-form`,
      {
        task_id: selectedRow?.task_id,
        currentSession: currentSession,
        base64Image: file,
        rows,
        totalCost,
        loadedLogo: normalizedLoadedLogo,
      },
      {
        withCredentials: true,
      },
    );

    if (!resp?.data?.success) {
      await dispatch(setSovTemplates(resp?.data?.data || []));
      return { success: false, message: resp?.data?.message };
    } else {
      return { success: true, data: resp?.data?.data };
    }
  } catch (error) {
    console.error("Failed to Create Document", error);
    return {
      success: false,
      message:
        "Failed to save the Schedule of Values document. Please try again later.",
    };
  } finally {
    await dispatch(setCreateScheduleLoading(false));
  }
};

export const handleUpdateSpecsManually =
  (mappedValues) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow } = state.myPermitsComponent;

    try {
      await dispatch(setCreateScheduleLoading(true));

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/city_permit/update-specs-man`,
        {
          task_id: selectedRow?.task_id,
          currentSession: currentSession,
          mappedValues: mappedValues,
        },
        {
          withCredentials: true,
        },
      );

      await dispatch(fetchJaxFields());

      if (!resp?.data?.success) {
        return { success: false, message: resp?.data?.message };
      } else {
        return { success: true, data: resp?.data?.data };
      }
    } catch (error) {
      console.error("Failed to Create Document", error);
      return {
        success: false,
        message:
          "Failed to save the Schedule of Values document. Please try again later.",
      };
    } finally {
      await dispatch(setCreateScheduleLoading(false));
    }
  };

export const updateScheduleValuesSignedUrl =
  () => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow } = state.myPermitsComponent;

    try {
      await dispatch(setScheduleOfValues({ scheduleOfValuesDocLoading: true }));

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/schedule-of-values/update-created-form-signed`,
        {
          task_id: selectedRow?.task_id,
          currentSession: currentSession,
        },
        {
          withCredentials: true,
        },
      );

      if (resp?.data?.success) {
        await dispatch(updatePermitPackage(resp?.data?.data));
        await dispatch(setSelectedRow(resp?.data?.data));
      } else {
        return;
      }
    } catch (error) {
      console.error(error);
    } finally {
      await dispatch(
        setScheduleOfValues({ scheduleOfValuesDocLoading: false }),
      );
    }
  };

export const handleDownloadScheduleForm = () => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const { selectedRow } = state.myPermitsComponent;

  try {
    await dispatch(setScheduleOfValues({ downloadLoading: true }));

    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/schedule-of-values/download-form`,
      {
        task_id: selectedRow?.task_id,
        currentSession: currentSession,
      },
      {
        withCredentials: true,
        responseType: "blob",
      },
    );
    const fileName = selectedRow?.permit_number
      ? selectedRow.permit_number.replace(/[-.]/g, "")
      : "unknown-permit";
    const blob = new Blob([resp.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `schedule-of-values_${fileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  } finally {
    await dispatch(setScheduleOfValues({ downloadLoading: false }));
  }
};

export const handleSaveScheduleValuesTemplate =
  (templateName) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow } = state.myPermitsComponent;
    const { rows, loadedLogo } = state.myPermitsComponent.scheduleOfValues;

    try {
      await dispatch(setScheduleOfValues({ savingTemplateLoading: true }));

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/schedule-of-values/save-template`,
        {
          task_id: selectedRow?.task_id,
          rows: rows,
          template_name: templateName,
          logo_url: loadedLogo,
          currentSession: currentSession,
        },
        {
          withCredentials: true,
        },
      );

      if (resp?.data?.success) {
        await dispatch(pushSovTemplate(resp?.data?.data));
        await dispatch(
          setUsingTemplates({
            isUsingTemplate: true,
            templateID: resp?.data?.data?.id,
            templateName: resp?.data?.data?.template_name,
            removedTemplate: false,
          }),
        );

        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    } finally {
      await dispatch(setScheduleOfValues({ savingTemplateLoading: false }));
    }
  };

export const fetchSovTemplates = () => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;

  try {
    await dispatch(setScheduleOfValues({ templatesLoading: true }));

    const resp = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/nocApi/schedule-of-values/templates?currentSession=${currentSession}`,
      {
        withCredentials: true,
      },
    );

    if (resp?.data?.success) {
      await dispatch(setSovTemplates(resp?.data?.data || []));
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error(error);
    return false;
  } finally {
    await dispatch(setScheduleOfValues({ templatesLoading: false }));
  }
};

export const handleRemoveTemplate = () => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const { templateID } = state.myPermitsComponent.usingTemplate;

  try {
    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/schedule-of-values/remove-template`,
      {
        templateID: templateID,
        currentSession: currentSession,
      },
      {
        withCredentials: true,
      },
    );

    if (resp?.data?.success) {
      await dispatch(removeSovTemplate(templateID));
      await dispatch(
        setUsingTemplates({
          removedTemplate: true,
        }),
      );

      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error(error);
  }
};

export const uploadDocumentJaxManually =
  (selectedFile, selectedDocId, setSelectedDocId) =>
  async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const { selectedRow } = state.myPermitsComponent;

    try {
      await dispatch(setPermitLoadings({ uploadDocLoading: true }));

      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("selectedDocId", selectedDocId);
      formData.append("task_id", selectedRow?.task_id);
      formData.append("currentSession", currentSession);

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/city_permit/upload-doc-man`,

        formData,

        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (resp?.data?.success) {
        setSelectedDocId("");
        dispatch(updateJaxDoc(resp?.data?.data));
        return { success: true, data: resp?.data?.data };
      } else {
        return { success: false, message: resp?.data?.message };
      }
    } catch (error) {
      console.error("Failed to upload document", error);
      return {
        success: false,
        message: "Failed to upload the document. Please try again later.",
      };
    } finally {
      await dispatch(setPermitLoadings({ uploadDocLoading: false }));
    }
  };
